import vuex from "src/vuex";
import * as Cookies from "js-cookie";

export default async (to, from, next) => {
  if(Cookies.getJSON("token") && await vuex.getters.isSettingsLoaded === false){
    try {
      await vuex.dispatch("fetchSettings");
    } catch (error) {
      console.error(error);
    }
  }
  next();
};
